import { Button } from "@babackapp/ui/components/button";
import { cn } from "@babackapp/ui/lib/utils";
import QuickFilterCountBadge from "./quick-filter-count-badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";

type QuickFilterProps = {
  active?: boolean;
  title: string;
  description: string;
  onClick: () => void;
  icon?: React.ReactNode | null;
  count?: number;
  tooltip?: string;
};

export default function QuickFilterItem({
  active,
  title,
  description,
  tooltip,
  onClick,
  icon,
  count,
}: QuickFilterProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "text-left justify-start items-start flex flex-col h-auto gap-2 whitespace-pre-wrap py-3",
            active && "border border-primary",
          )}
          onClick={onClick}
        >
          <span className="inline-flex items-center text-xs gap-3">
            {icon}
            {title}
            <QuickFilterCountBadge count={count} />
          </span>
          <p className="text-xs w-[180px] text-muted-foreground">
            {description}
          </p>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
